module.exports = __webpack_public_path__ + "img/injective-9.abf718f3.webp";